import script from "./error.vue?vue&type=script&lang=js&setup=true"
export * from "./error.vue?vue&type=script&lang=js&setup=true"

import "./error.vue?vue&type=style&index=0&id=44a371c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44a371c8"]])

export default __exports__